module.exports = __webpack_public_path__ + "static/media/IMG_4580 sink and top - Copy.28dd71aa.JPG";